<template>
  <form @submit.prevent="showSubmitConfirmation">
    <div>
      <div class="spinner-wrap" v-if="!dataIsLoaded">
        <Spinner />
      </div>
      <div class="content-wrap" v-else>
        <div class="content">
          <div class="brokers-wrap">
            <div class="form-header">
              <h3 class="brokers-title">Trip Report</h3>
              <div class="wrap-multiselect">
                <span class="label-multiselect">You have reports in progress</span>
                <Multiselect
                  v-model="selectedElem"
                  :options="brokerReports"
                  label="reportName"
                  track-by="id"
                  :select-label="'Select'"
                  :deselect-label="'Remove'"
                  placeholder="Select Report"
                  class="select-items"
                  @input="updateUrl"
                />
              </div>
            </div>
            <!-- Dynamic form -->
            <div
              class="row"
              v-for="question of broker.questions"
              :key="question.id"
            >
              <h3 class="category-title" v-if="isNewCategory(question)">
                {{ question.category }}
              </h3>

              <div class="question-wrap">
                <label :class="question.questionType"
                  >{{ question.question
                  }}<strong v-if="question.required"> *</strong></label
                >

                <div
                  class="question-input"
                  v-if="question.questionType === 'Radiobutton'"
                >
                  <div
                    v-bind:class="question.questionType"
                    v-bind:key="option.id"
                    v-for="option in question.options"
                  >
                    <input
                      type="radio"
                      class="form-control"
                      v-model="question.answer"
                      :value="option.option"
                      @change="() => saveBroker(false)"
                      :id="option.id"
                    />
                    <label :for="option.id">{{ option.option }}</label>
                  </div>
                </div>

                <div
                  class="question-input dropdown-type-of-report"
                  v-if="question.questionType === 'Dropdown'"
                >
                  <custom-select
                    required="question.answer ? '' : 'required'"
                    class="form-control"
                    :question="question"
                    v-model="selectedTypeOfReport"
                    @input="(value) => { changeTypeOfReport(value); saveBroker(false); }"
                  ></custom-select>

                  <div  
                    v-if="!selectedTypeOfReport && !typeOfReportDropdown" 
                    class="tooltip-wrap"
                  >
                    <div class="tooltip-triangle"></div>
                    <div class="tooltip-content">
                      <img class="tooltip-img" src="@/assets/exclamation-icon.png" alt="exclamation-icon" />
                      <span class="tooltip-text">Please fill out this fied.</span>
                    </div>
                  </div>

                </div>

                <div
                  class="question-input dropdown multiselect-wrap dropdown-operator-name"
                  v-if="question.questionType === 'Dropdown (query)'"
                >
                  <Multiselect
                    v-model="selectedOperatorName"
                    :options="operators.map(operator => operator.operatorName)"
                    :select-label="'Select'"
                    :deselect-label="'Remove'"
                    placeholder="Select an option"
                    class="select-items"
                    @input="(value) => { changeOperator(value); saveBroker(false); }"
                    @tag="(newTag) => { createOperatorName(newTag); saveBroker(false);}"
                    taggable
                    tag-placeholder="Create new Operator Name"
                  />

                  <div
                    v-if="!selectedOperatorName && !operatorNameDropdown" 
                    class="tooltip-wrap"
                  >
                    <div class="tooltip-triangle"></div>
                    <div class="tooltip-content">
                      <img class="tooltip-img" src="@/assets/exclamation-icon.png" alt="exclamation-icon" />
                      <span class="tooltip-text">Please fill out this fied.</span>
                    </div>
                  </div>

                  <!-- <CustomSelectQuery
                    v-model="question.answer"
                    :options="operators.map(operator => operator.operatorName)"
                    class="select-items select-operator"
                    @input="() => { saveBroker(false); changeOperator(question.answer); }"
                  /> -->

                </div>

                <div
                  class="question-input"
                  :class="question.questionType"
                  v-else-if="question.questionType === 'Yes/No'"
                >
                  <div :class="question.questionType" class="Radiobutton">
                    <input
                      type="radio"
                      class="form-control"
                      v-model="question.answer"
                      :name="question.id + 'Yes'"
                      value="Yes"
                      @change="() => saveBroker(false)"
                    />
                    <label :for="question.id + 'Yes'">Yes</label>
                  </div>
                  <div :class="question.questionType" class="Radiobutton">
                    <input
                      type="radio"
                      class="form-control"
                      v-model="question.answer"
                      :name="question.id + 'No'"
                      value="No"
                      @change="() => saveBroker(false)"
                    />
                    <label :for="question.id + 'No'">No</label>
                  </div>
                </div>

                <div
                  class="question-input"
                  :class="question.questionType"
                  v-else-if="question.questionType === 'Multiline'"
                >
                  <textarea
                    class="form-control"
                    v-model="question.answer"
                    @change="() => saveBroker(false)"
                    rows="4"
                    :required="question.required"
                  />
                </div>

                <div
                  class="question-input"
                  :class="question.questionType"
                  v-else-if="question.questionType === 'Yes/No/else'"
                >
                  <div :class="question.questionType" class="Radiobutton">
                    <input
                      type="radio"
                      class="form-control"
                      v-model="question.answer"
                      :name="question.id + 'Yes'"
                      value="Yes"
                      @change="() => saveBroker(false)"
                    />
                    <label :for="question.id + 'Yes'">Yes</label>
                  </div>
                  <div :class="question.questionType" class="Radiobutton">
                    <input
                      type="radio"
                      class="form-control"
                      v-model="question.answer"
                      :name="question.id + 'No'"
                      value="No"
                      @change="() => saveBroker(false)"
                    />
                    <label :for="question.id + 'No'">No</label>
                  </div>
                  <div :class="question.questionType" class="Radiobutton">
                    <input
                      type="radio"
                      class="form-control"
                      :name="question.id + 'Other'"
                      value=""
                      @change="
                        () => {
                          question.answer = 'Other:';
                          saveAssessment(false);
                        }
                      "
                      v-bind="{
                        checked:
                          question.answer &&
                          question.answer !== 'Yes' &&
                          question.answer !== 'No'
                      }"
                    />
                    <label :for="question.id + 'Other'">Other</label>
                  </div>
                  <div
                    :class="question.questionType"
                    class="Radiobutton"
                    v-if="
                      question.answer &&
                        question.answer !== 'Yes' &&
                        question.answer !== 'No'
                    "
                  >
                    <label>Please Specify</label>
                    <!-- Remove "Other: " from textarea view -->
                    <textarea
                      class="form-control"
                      @change="
                        e => {
                          question.answer = 'Other: ' + e.target.value;
                          saveAssessment(false);
                        }
                      "
                      >{{ question.answer.replace("Other:", "") }}</textarea
                    >
                  </div>
                </div>

                <div
                  class="question-input"
                  :class="question.questionType"
                  v-else-if="question.questionType === 'Date'"
                >
                  <!-- Dates are stored as text and should be read/written in a format of mm/dd/yyyy -->
                  <input
                    :required="question.required"
                    type="date"
                    class="form-control"
                    @change="
                      e => {
                        question.answer = writeFormatedDate(e.target.value);
                        saveBroker(false);
                      }
                    "
                    :value="readFormatedDate(question.answer)"
                  />
                </div>

                <div
                  class="question-input"
                  :class="question.questionType"
                  v-else-if="
                    !question.questionType || question.questionType === 'Text'
                  "
                >

                  <input
                    type="text"
                    class="form-control"
                    v-model="question.answer"
                    @change="() => saveBroker(false)"
                    :required="question.required"
                  />
                </div>

                <div
                  class="question-input"
                  :class="question.questionType"
                  v-else-if="
                    !question.questionType ||
                      question.questionType === 'Numeric'
                  "
                >
                  <input
                    :required="question.required"
                    type="text"
                    class="form-control"
                    @input="filterNumbers(question)"
                    v-model="question.answer"
                    required
                    @change="() => saveBroker(false)"
                  />
                </div>

                <div
                  class="question-input"
                  v-if="question.questionType === 'File'"
                  :class="question.questionType"
                >
                  <vue-dropzone
                    id="dropzone"
                    ref="myVueDropzone"
                    :options="dropzoneOptions"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-wrap" v-if="dataIsLoaded">
        <div class="footer-wrap-content">
          <button style="background: none; border: none" type="submit">
            <HeadBtn text="Final Submit" :click="() => {}" />
          </button>
          <span class="submit-message">Once you submit the report, you will not be able to make any further updates.</span>
        </div>
      </div>
    </div>

    <SubmitConfirmation
      :on-confirm="() => saveBroker(true)"
      :on-cancel="cancelPopup"
      report-name="Trip"
      v-if="showSubmitPopup"
    />

  </form>
</template>

<script>
import Spinner from "../../../components/Spinner.vue";
import HeadBtn from "../../../components/HeadBtn.vue";
import Multiselect from "vue-multiselect";
import vue2Dropzone from "vue2-dropzone";
import CustomSelect from "../../../components/SelectGroup.vue";
import CustomSelectQuery from "../../../components/Select.vue"
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import SubmitConfirmation from "@/components/pop-up/SubmitConfirmation.vue";

import { getBrokerReports, submitReport, uploadFiles, getAllOperators, saveOperatorId } from "@/api/brokers";

let currentCategory = "all";

export default {
  name: "Broker",
  data: function() {
    const recordId = this.$route.params.recordId;
    return {
      typeOfReportDropdown: true,
      operatorNameDropdown: true,
      dataIsLoaded: false,
      broker: {},
      questions: [],
      operators: [],
      selectedElem: null,
      selectedTypeOfReport: null,
      selectedOperatorName: null,
      brokerReports: {},
      questionIdForDoc: "",
      showSubmitPopup: false,
      dropzoneOptions: {
        url: `http://localhost`,
        // addRemoveLinks: true,
        // maxFiles: 10,
        // thumbnailWidth: 150,
        // thumbnailHeight: 150,
        autoProcessQueue: false,
        thumbnailWidth: null,
        previewTemplate: `<div class="dz-preview">
                            <div class="dz-details">
                              <div class="dz-filename">
                                <span data-dz-name></span>
                                <a href="#" class="dz-remove" data-dz-remove>
                                  <span>✖</span>
                                </a>
                              </div>
                            </div>
                          </div>`,
        init: function() {
          const myDropzone = this;
          const vueComponent = this.options.vueComponent;
          myDropzone.on("addedfile", function(file) {
            const reader = new FileReader();
            reader.onload = function(event) {
              const base64String = btoa(event.target.result);
              const sendString = `${file.name}!${base64String}`;
              uploadFiles(vueComponent.questionIdForDoc, sendString)
                .then(data => {
                  console.log(data);
                  if ("status_code" in data && data.status_code === 200) {
                    myDropzone.emit("complete", file);
                    myDropzone.emit("success", file);
                  } else {
                    myDropzone.emit("error", file, "Error uploading file");
                    myDropzone.emit("canceled", file);
                  }
                })
                .catch(() => {
                  myDropzone.emit("error", file, "Error uploading file");
                  myDropzone.emit("canceled", file);
                });
            };
            reader.readAsBinaryString(file);
          });
        },
        vueComponent: this
      }
    };
  },
  components: {
    Spinner,
    HeadBtn,
    Multiselect,
    SubmitConfirmation,
    CustomSelect,
    CustomSelectQuery,
    vueDropzone: vue2Dropzone
  },
  async mounted() {
    await this.loadBroker();

    window.scrollTo(0, 0);
  },
  watch: {
    "$route.params.recordId": "loadBroker"
  },

  methods: {
    async createOperatorName(selectedElem) {
      this.selectedOperatorName = selectedElem
      this.broker.questions[5].answer = this.selectedOperatorName

      const response = await saveOperatorId(this.$route.params.recordId, 267);
      console.log("UpdatedRelatedField", response)
    },

    async changeTypeOfReport(selectedElem) {
      this.selectedTypeOfReport = selectedElem
      this.broker.questions[4].answer = this.selectedTypeOfReport
    },

    async changeOperator(selectedElem) {
      this.selectedOperatorName = selectedElem
      this.broker.questions[5].answer = this.selectedOperatorName
      
      const selectedOperator = this.operators.find(operator => operator.operatorName === this.selectedOperatorName);

      if (selectedOperator) {
        const operatorId = selectedOperator.id;

        const response = await saveOperatorId(this.$route.params.recordId, operatorId);
        console.log("UpdatedRelatedField", response)
      }
    },

    showSubmitConfirmation() {
      if (!this.selectedTypeOfReport) {
        this.typeOfReportDropdown = false;
        return;
      } 
      
      if (!this.selectedOperatorName) {
        this.operatorNameDropdown = false;
        return;
      } 
      
      this.showSubmitPopup = true;
    },

    cancelPopup() {
      this.showSubmitPopup = false;
    },

    updateUrl(elem) {
      this.selectedElem = elem;
      const selectedRecordId = this.selectedElem.id;

      this.$router.push(
        `/brokers/${this.$route.params.brokerId}/${selectedRecordId}`
      );
    },

    async loadBroker() {
      this.$store.commit("header/setData", {
        title: ``,
        description: ``,
        showLogo: true,
        showLogoutBtn: false
      });

      this.dataIsLoaded = false;

      this.broker = await this.$store.dispatch(
        "brokers/fetchEntryData",
        this.$route.params.recordId
      );

      if (this.broker.status === "Submitted" || this.broker.status === "Completed") {
        this.$router.push({
          name: "Page404",
          params: {
            errorMessage: "Trip Report is Completed",
          },
        });
      }

      this.selectedOperatorName = this.broker.questions[5].answer
      this.questionIdForDoc = this.broker.questions[8].id

      const response = await getBrokerReports(this.$route.params.brokerId);
      this.brokerReports = response.reports;

      if (!this.selectedElem) {
        this.brokerReports.map(report => {
          if (report.id == this.$route.params.recordId) {
            this.selectedElem = report;
          }
        });
      }

      const responseOperators = await getAllOperators();
      this.operators = responseOperators;

      this.dataIsLoaded = true;

      if (!this.broker) {
        console.error(
          `Broker with id ${this.$route.params.recordId} not found.`
        );
      }

      this.$store.commit("header/setData", {
        title: `Report for ${this.broker.brokerName}`,
        description: ``,
        showLogo: true,
        showLogoutBtn: false
      });
    },

    // validateBeforeSave() {
    //     this.questionsError = {};
    //     for (let question of this.broker.questions) {
    //       if (question.questionType && (question.questionType === 'Numeric' || question.questionType === 'Numeric' || question.questionType === 'Numeric' ||))
    //     }
    // }
    async saveBroker(finished = false) {
      this.showSubmitPopup = false;

      // console.log("allAnswer", this.broker)
      
      if (finished) this.dataIsLoaded = false;
      if (finished) {
        // Remove "Other: " from yes/no/other questions
        this.broker.questions.forEach(question => {
          if (
            question.questionType === "Yes/No/else" &&
            question.answer.startsWith("Other: ")
          ) {
            question.answer = question.answer.replace("Other: ", "");
          }
        });
      }

      await this.encodeFilesInQuestions();

      await this.$store.dispatch("brokers/saveBroker", { data: this.broker });

      if (finished) {
        const response = await submitReport(this.$route.params.recordId);
        console.log("submitReportResponse", response);

        this.dataIsLoaded = true;

        this.$router.push({ name: "ThankYou" });
      }

      //   if (finished) this.$router.push({ name: 'ThankYou' });
    },
    encodeFilesInQuestions() {
      return new Promise(resolve => {
        let noQuestionsEncoding = 0;
        this.broker.questions.forEach(question => {
          // Base64 encode file attachment and filename (delimit using /) in questions
          if (question.questionType === "File") {
            let file = question.file;
            if (file) {
              let reader = new FileReader();
              noQuestionsEncoding++;
              reader.onload = () => {
                console.log(reader.result);
                let encoded = btoa(reader.result);
                question.answer = `${file.name}!${encoded}`;

                noQuestionsEncoding--;

                if (noQuestionsEncoding === 0) {
                  resolve();
                }
              };
              reader.readAsText(file);
            }
          }
        });

        if (noQuestionsEncoding === 0) {
          resolve();
        }
      });
    },
    isNewCategory(question) {
      if (question.category !== currentCategory) {
        currentCategory = question.category;
        return true;
      }
    },
    getOptionGroups(options) {
      let groups = [""];
      options.forEach(option => {
        let optionGroup = option.option.split(" - ")[0] || option.option;
        if (!groups.find(group => group.label === optionGroup)) {
          groups.push({ label: optionGroup, options: [] });
        }
        groups.find(group => group.label === optionGroup).options.push(option);
      });
      console.log("groups", groups);
      return groups;
    },
    readFormatedDate(date) {
      if (!date) return "";
      let dateParts = date.split("/");
      return `${dateParts[2]}-${dateParts[0]}-${dateParts[1]}`;
    },
    writeFormatedDate(date) {
      console.log(date);
      if (!date) return "";

      let month = date.split("-")[1];
      let day = date.split("-")[2];
      let year = date.split("-")[0];

      return `${month}/${day}/${year}`;
    },
    filterNumbers(question) {
      question.answer = question.answer.replace(/\D/g, "");
    }
  }
};
</script>

<style>
  #dropzone {
    padding: 15px;
  }

  #dropzone .dz-preview {
    position: static;
    display: block;
    min-height: 10px;
    margin: 0 0 10px 0;
    background-color: transparent;
  }

  #dropzone .dz-preview:last-child {
    margin: 0;
  }

  #dropzone .dz-details {
    opacity: 1;
    position: static;
    padding: 0;
    background-color: transparent;
  }

  #dropzone .dz-filename {
    display: flex;
  }

  #dropzone .dz-filename span {
    color: #0f2e50;
    font-size: 1.2em;
    padding: 0;
  }

  #dropzone .dz-remove {
    position: static;
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    border: none;
    opacity: 1;
    cursor: pointer;
  }

  #dropzone .dz-remove span {
    color: #e53434;
    cursor: pointer;
  }

  .select-items.select-operator {
    width: 100% !important;
    color: #333;
    z-index: 10;
  }

  .select-items.select-operator .multiselect__tags {
    border-radius: 0;
    min-height: 46px;
    padding-top: 12px;
  }

  .select-items.select-operator .multiselect__single {
    font-size: 19px;
  }

  /* Custom scroll for Operator Name */
  .multiselect-wrap {
    z-index: 1 !important;
  }
  .multiselect-wrap .select-items {
    width: 100% !important;
  }
  .multiselect-wrap .multiselect__tags {
    min-height: 46px;
    padding: 9px 40px 0 10px;
    border-radius: 0;
  }
  .multiselect-wrap .multiselect__placeholder {
    font-size: 1.35em;
    color: #333 !important;
  }
  .multiselect-wrap .multiselect__single {
    padding: 2px 0 0;
    font-size: 1.35em;
    color: #333;
  }
  .multiselect-wrap .multiselect__select {
    right: -4px;
    top: 3px;
  }
  .multiselect-wrap .multiselect__select::before {
    color: #333;
  }
  .multiselect__content-wrapper {
    cursor: pointer !important;
  }
  .multiselect__content-wrapper::-webkit-scrollbar {
    width: 12px;
    background-color: #fff;
  }
  .multiselect__content-wrapper::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: linear-gradient(to bottom, #3c6399 0%, #0f2e50 100%);
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
  }
  .multiselect__content-wrapper::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  }

</style>

<style scoped>

.btn-primary {
  background-color: #007bff;
  color: #fff;
}

.spinner-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.content-wrap {
  display: flex;
  flex-direction: column;
}

.slider {
  background-color: #1e4775;
  padding: 20px;
  border-bottom: 1px solid #dee2e6;
}

.brokers-wrap {
  display: flex;
  flex-direction: column;

  padding: 0 1.5em 1.5em;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.content {
  max-width: 900px;
  margin: 0 auto 96px;
  width: 95%;
}

.brokers-wrap .header {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.brokers-wrap .header .row {
  display: flex;
  justify-content: space-between;
}

.brokers-wrap .content .row {
  margin-bottom: 20px;
}

.question-wrap {
  display: flex;
  flex-direction: row;
  padding: 7px 1em;
  background: #efefef;
  font-weight: 500;
}

.question-wrap label {
  /*margin-bottom: 5px;*/
  margin: auto;
  width: 51%;
  text-align: right;
  padding-right: 0.8em;
  /*padding-top: 0.65em;*/
  /*color: #666;*/
  color: #0f2e50;
  font-size: 1.3em;
  /* display: flex;
	  align-items: center;
	  justify-content: flex-end; */
}

.label-multiselect {
  display: block;
  margin-bottom: 3px;
  color: #0f2e50;
  font-size: 1.1em;
  font-weight: 600;
}

.submit-message {
  margin-left: 30px;
  color: #0f2e50;
  font-size: 1.1em;
  font-weight: 600;
  position: relative;
  top: 5px;
  font-style: italic;
}

strong {
  color: rgb(191, 30, 46);
}

.question-wrap input {
  /*margin-bottom: 10px;*/
  padding: 10px;
  flex: 1;
  border: 1px solid white;
  font-family: "Poppins", sans-serif;
  font-size: 1.25em;
  cursor: pointer;
  /*border-radius: 8px;*/
  outline: none;
  /*color: #4e4e4e;*/
  color: #333;
}

.question-wrap input:hover {
  border: 1px solid #0f2e50;
}

.question-wrap input:focus {
  border: 1px solid black;
}

.dropdown {
  z-index: 0;
}

.question-input textarea {
  margin-bottom: 10px;
  padding: 10px;
  flex: 1;
  border: 1px solid white;
  font-family: "Poppins", sans-serif;
  font-size: 1.25em;
  cursor: pointer;
  /*border-radius: 8px;*/
  outline: none;
  /*color: #4e4e4e;*/
  color: #333;
}

.question-input textarea:hover {
  border: 1px solid #0f2e50;
}

.question-input textarea:focus {
  border: 1px solid black;
}

.question-input,
.question-input input:not([type="radio"]),
.question-input textarea {
  width: 100%;
}

.File {
  width: 100%;
  margin-top: 5px;
  z-index: 0;
}

.form-header {
  padding: 3em 0 0.7em;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.select-items {
  width: 300px;
}

.brokers-title {
  font-size: 1.5em;
  font-weight: 700;
  margin: 0;
}

.category-title {
  font-size: 1.5em;
  font-weight: 700;
  /*padding: 2em 0 0.5em;*/
  margin: 0;

  /*border-top: 0.75em solid #efefef;*/
  /*border-bottom: 0.75em solid #efefef;*/
  border-left: none;
  border-right: none;
}

.row:first-child .category-title {
  border-top: none;
}

.Header {
  font-size: 1.125em;
}

.question-wrap .Header {
  width: 100%;
  text-align: left;
}

.question-input .Radiobutton input[type="radio"] {
  margin-right: 10px;
}

.question-input .Radiobutton {
  /* padding-bottom: 1em; */
  padding-top: 0.25em;
}

.question-input .Radiobutton:first-child {
  padding-top: 0.65em;
}

.question-input .Radiobutton label {
  /* display: initial; */
  padding-top: 0;
  color: #333;
  color: #4e4e4e;
}

.c-head-btn {
  margin: 20px 0 10px 0;
}

.footer-wrap {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  border-top: 1.5px solid #c9cacb;
}

.footer-wrap-content {
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.footer-wrap .c-head-btn {
  width: fit-content;
}

select {
  width: 100%;
  padding: 10px;
  border: 1px solid white;
  font-family: "Poppins", sans-serif;
  font-size: 1.25em;
  background: white;
  cursor: pointer;
  outline: none;
  color: #333;
}

select optgroup {
  font-size: 0.7em;
  border-bottom: 1px solid #dae0e5;
}

select option {
  font-size: 1.25em;
  color: black;
  border-bottom: 1px solid #dae0e5;
  padding: 5px 0;
}

select:hover {
  border: 1px solid #0f2e50;
}

select:focus {
  border: 1px solid black;
}

select optgroup:nth-of-type(1) {
  color: rgb(96, 144, 125);
}

select optgroup:nth-of-type(2) {
  color: green;
}

select optgroup:nth-of-type(3) {
  color: blue;
}

select optgroup:nth-of-type(4) {
  color: purple;
}

select optgroup:nth-of-type(5) {
  color: orange;
}

select optgroup:nth-of-type(6) {
  color: rgb(125, 183, 183);
}

select optgroup:nth-of-type(7) {
  color: brown;
}

select optgroup:nth-of-type(8) {
  color: rgb(173, 125, 133);
}

select optgroup:nth-of-type(9) {
  color: black;
}

.dropdown-operator-name,
.dropdown-type-of-report {
  position: relative;
}

.dropdown-type-of-report {
  z-index: 2;
}

.tooltip-wrap {
  position: absolute;
  bottom: calc(-100% - 9px);
  left: 175px;
  width: 190px;
  height: 45px;
  background-color: #fff;
  border: 1px solid #6b6264;
  border-radius: 4px;
  display: flex;
  align-items: center;
  -webkit-box-shadow: 4px 4px 10px -5px rgba(0,0,0,0.75);
  -moz-box-shadow: 4px 4px 10px -5px rgba(0,0,0,0.75);
  box-shadow: 4px 4px 10px -5px rgba(0,0,0,0.75);
  z-index: 1;
}

.tooltip-triangle {
  width: 0;
  height: 0;
  border: 0 solid transparent;
  border-right-width: 8px;
  border-left-width: 8px;
  border-bottom: 8px solid #fff;
  position: absolute;
  top: -8px;
  left: 10px;
}

.tooltip-triangle::after {
  content: "";
  position: absolute;
  left: -9px;
  top: -1px;
  width: 0;
  height: 0;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 9px solid black;
  z-index: -1;
}

.tooltip-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 7px;
}

.tooltip-img {
  width: 25px;
  height: 25px;
}

.tooltip-text {
  font-size: 14px;
}

@media screen and (max-width: 768px) {
  .form-header {
    padding-top: 2em;
  }

  .submit-message {
    font-size: 1em;
    margin-left: 15px;
  }

  .category-title {
    font-size: 1.3em;
  }

  .question-wrap label {
    font-size: 1.1em;
  }

  .question-wrap input,
  .question-input textarea,
  select {
    font-size: 1.05em;
  }
}

@media screen and (max-width: 550px) {
  .form-header {
    flex-wrap: wrap;
    padding-top: 0.5em;
  }

  .wrap-multiselect,
  .multiselect.select-items {
    width: 100%;
  }

  .content {
    width: 100%;
    margin-bottom: 90px;
  }

  .brokers-title {
    padding: 1em 0 0.75em;
    font-size: 1.1em;
  }

  .question-wrap {
    flex-direction: column;
    padding: 0.2em 1em;
  }

  .question-wrap label {
    width: 100%;
    text-align: left;
    font-size: 1em;
    padding-top: 0.3em;
    margin-bottom: 5px;
  }

  .question-wrap input {
    margin-bottom: 5px;
    font-size: 1em;
  }

  select {
    font-size: 0.9em;
  }

  .question-input.File .form-control {
    font-size: 1em;
  }

  .c-head-btn {
    margin: 10px 0;
  }

  .footer-wrap-content {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding: 0 1.5em;
  }

  .submit-message {
    margin: 0 0 10px 0;
    position: static;
    text-align: center;
  }
}
</style>
